export default __webpack_public_path__ + "static/media/Web.36044793.png";